import { useMemo } from "react";
import { Link } from "react-router-dom";
import MovieCard from "@/components/feature/MovieCard";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { usePageMeta } from "@/hooks/usePageMeta";
import { useFavorites } from "@/hooks/useFavorites";
import { movies } from "@/mocks/movies";

export default function Favorites() {
  const { favorites, toggleFavorite } = useFavorites();
  usePageMeta(
    "我的收藏 - 91在线视频",
    "在91在线视频查看你收藏的电影、电视剧及综艺节目。收藏记录保存在当前浏览器，可随时添加或移除。",
  );

  const list = useMemo(
    () => movies.filter((m) => favorites.includes(m.id)),
    [favorites],
  );

  return (
    <div className="mx-auto w-full max-w-screen-2xl px-4 py-6 md:px-8 md:py-8">
      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "我的收藏" }]} />

      <div className="mt-4 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="font-heading text-2xl font-700 text-foreground-950 md:text-3xl">
            我的收藏
          </h1>
          <p className="mt-1 text-sm text-foreground-500">
            收藏记录保存在当前浏览器，共{" "}
            <span className="font-600 text-accent-500">{list.length}</span> 部作品
          </p>
        </div>
        {list.length > 0 && (
          <button
            type="button"
            onClick={() => list.forEach((m) => toggleFavorite(m.id))}
            className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300/60 px-4 py-2 text-sm text-foreground-600 transition-colors hover:border-accent-500 hover:text-accent-500"
          >
            <i className="ri-delete-bin-6-line" />
            清空收藏
          </button>
        )}
      </div>

      {list.length === 0 ? (
        <div className="mt-8 flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-background-300/60 py-20 text-center text-foreground-500">
          <i className="ri-heart-3-line text-5xl" />
          <p className="text-base font-600 text-foreground-700">你还没有收藏任何影视作品</p>
          <p className="text-sm">在影视卡片或详情页点击爱心即可加入收藏</p>
          <Link
            to="/category/movie"
            className="mt-2 flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-600 text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-compass-3-line" />
            去发现好片
          </Link>
        </div>
      ) : (
        <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-4 xl:grid-cols-5">
          {list.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      )}
    </div>
  );
}